module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'ihjr9qdb',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
